<div class="container">
    <div class="row me-landing-page-marquee">
        <div class="col-xs-12">
            <div class="label">{{data.label}}</div>
        </div>
        <div class="col-xs-12">
            <div class="image-marquee-container">
                <div class="image-marquee">
                    <img *ngFor="let img of data['images']" src="{{img.filename}}">
                    <img *ngFor="let img of data['images']" src="{{img.filename}}">
                </div>
            </div>
        </div>
    </div>
</div>
